const { server_ip }= require('../config');

async function validToken(token){
    try {
        const response= await fetch(`${server_ip}/api/valid`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

async function loginWithPassword(username,password){
    try {
        const response= await fetch(`${server_ip}/api/users/login`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username,password
            }),
        })
        return await response.json();
    } catch (error) {
        alert('請檢查網路連接或稍後再試');
    }
}

async function changePassword(token,password,oldPassword){
    try {
        const response= await fetch(`${server_ip}/api/users/changePW`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                password,
                oldPassword
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
async function fetchUserList(token,option={}){
    try {
        const response= await fetch(`${server_ip}/api/users/admin/list?option=${JSON.stringify(option)}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
async function adminChangePassword(token,userId,password){
    try {
        const response= await fetch(`${server_ip}/api/users/admin/changePW`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                password,
                userId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
async function teacherChangePassword(token,userId,password){
    try {
        const response= await fetch(`${server_ip}/api/users/teacher/changePW`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                password,
                userId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export {
    validToken,
    loginWithPassword,
    
    changePassword,
    fetchUserList,
    adminChangePassword,
    teacherChangePassword
}